import { useEffect } from 'react'
import { Helmet } from 'react-helmet'

import Brand from 'helpers/brand'
import Environment from 'helpers/environment'
import GA4 from 'helpers/ga4'
import Apptentive from 'helpers/apptentive'
import Amplitude from 'helpers/amplitude'
import { configureAutoTrack } from '@nexiahome/ui-common/utils/kinesisAnalytics'

const Head = () => {
  const googleAnalyticsId = GA4.googleAnalyticsId()

  useEffect(() => {
    Amplitude.init()

    configureAutoTrack('DWA', { enable: true, type: 'session' })
    configureAutoTrack('DWA', { enable: true, type: 'pageView' })
  }, [])

  return (
    <Helmet>
      <title>{Brand.productName()}</title>

      <link rel="shortcut icon" href={Brand.faviconPath()} />

      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta
        httpEquiv="X-UA-Compatible"
        content="IE=edge,chrome=1"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap" rel="stylesheet" />

      {Brand.isResidential() && (
        <script async src={'//www.googletagmanager.com/gtag/js?id=' + googleAnalyticsId} />
      )}

      {Brand.isResidential() && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        `}
        </script>
      )}

      {Brand.isResidential() && (
        <script>{'(function initApptentiveSDK(){var ApptentiveSDK=window.ApptentiveSDK=window.ApptentiveSDK||[];if(!ApptentiveSDK.version){if(!ApptentiveSDK.loaded){ApptentiveSDK.loaded=true;ApptentiveSDK.methods=["buildDevice","createConversation","createMessage","engage","getSegments","identifyPerson","setOption","setPageName","showInteraction","showMessageCenter","updatePerson"];ApptentiveSDK.factory=function factory(t){return function f(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}var e=Array.prototype.slice.call(args);e.unshift(t);ApptentiveSDK.push(e);return ApptentiveSDK}};for(var i=0;i<ApptentiveSDK.methods.length;i++){var method=ApptentiveSDK.methods[i];ApptentiveSDK[method]=ApptentiveSDK.factory(method)}ApptentiveSDK.LOADER_VERSION="1.0.0"}}})();'}</script>
      )}

      {Brand.isResidential() && (<script async src={`https://sdk.apptentive.com/v1/apps/${Apptentive.getApptentiveAccountId()}/websdk`} />)}

      {Environment.isProduction() && (
        <script src="//rum-static.pingdom.net/pa-58121709293aecd24d0285b8.js" async />
      )}

    </Helmet>
  )
}

export default Head
